import { service } from '../../service';

const state = {
  clientName: '',
  authToken: '',
  isSuperAdmin: false,
  permissions: {},
  useJitsi: false,
};

const mutations = {
  setAuthToken(state, authToken) {
    state.authToken = authToken;
  },
  setIsSuperAdmin(state, isSuperAdmin) {
    state.isSuperAdmin = isSuperAdmin;
  },
  setPermissions(state, modules) {
    state.permissions = modules;
  },
  setClientName(state, clientName) {
    state.clientName = clientName;
  },
  setUseJitsi(state, useJitsi) {
    state.useJitsi = useJitsi;
  },
};

const actions = {
  async getUserParams({ commit }) {
    // commit('setIsSuperAdmin', true);
    //const { data } = await service.getUserParams(cryptext);
    //commit('setIsSuperAdmin', true);
    // commit('setAuthToken', data.userData.auth_token);
    // commit('setPermissions', data.userData.modules);
    // commit('setClientName', data.client);
    // window.ApiToken = data.userData.auth_token;
    // window.client = data.client;
  },
};

const getters = {
  /* getSelected: state => state.selected,*/
  getUseJitsi: state => state.useJitsi,
  hasPermission: state => permissions =>
    permissions.split(',').some(v => state.permissions[v]) || state.isSuperAdmin,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js